import {ADD_PDF_REPORT_REQUEST, GET_PDF_PAYLOAD_BY_ID_REQUEST, GET_PDF_REPORT_BY_NAME_REQUEST, GET_PDF_REPORT_REQUEST, SEND_PDF_REPORT_EMAIL_REQUEST} from './actionTypes';

export const addPdfReport = (payload, templateType) => ({
  type: ADD_PDF_REPORT_REQUEST,
  payload: {
    payload,
    address: payload.address,
    client: payload.client,
    elevator: payload.elevator,
    period: payload.period,
    project: payload.project,
    elevatorId: payload.elevatorId,
    image: payload.image,
    templateType,
  },
});

export const getPdfReports = (filters = {}) => ({
  type: GET_PDF_REPORT_REQUEST,
  filters,
});

export const getPdfPayloadById = (id) => ({
  type: GET_PDF_PAYLOAD_BY_ID_REQUEST,
  id,
});

export const getPdfReportsByName = (elevatorName, filters = {}) => ({
  type: GET_PDF_REPORT_BY_NAME_REQUEST,
  elevatorName,
  filters,
});

export const sendPdfByMail = (formData) => {
  return {
    type: SEND_PDF_REPORT_EMAIL_REQUEST,
    payload: formData
  };
};
